import { Commodities } from "./types";
import { Commodity } from "./Commodity/types";

const filterCommodities = (
  commodity: Commodity,
  index: number,
  commodities: Commodity[]
) =>
  commodities.findIndex(
    (findIndexCommodity: Commodity) =>
      findIndexCommodity.commodityDesc === commodity.commodityDesc &&
      findIndexCommodity.packagingType === commodity.packagingType
  ) === index;

export const getLoadCommodities = (
  loadCommodityList: any[] = []
): Commodities => {
  const filteredCommodities: Commodity[] = loadCommodityList.filter(
    filterCommodities
  );
  
  const detailsCommodities = filteredCommodities.slice(0, 4);
  const additionalCommodities = filteredCommodities.slice(4);

  return { detailsCommodities, additionalCommodities };
};

export const getLoadStopCommodities = (loadStop: any[] = []): Commodities => {
  const sortedMergedCommodities: Commodity[] = [...loadStop]
    .sort(
      ({ sequenceNo }: any, { sequenceNo: sequenceNo2 }: any) =>
        sequenceNo - sequenceNo2
    )
    .map(
      ({ stopCommodity = [] }: { stopCommodity: Commodity[] }) => stopCommodity
    )
    .reduce(
      (prevCommodity: Commodity[] | any[], currCommodity: Commodity[]) =>
        prevCommodity.concat(currCommodity),
      []
    )
    .filter(filterCommodities);

  const detailsCommodities = sortedMergedCommodities.slice(0, 4);
  const additionalCommodities = sortedMergedCommodities.slice(4);

  return { detailsCommodities, additionalCommodities };
};
